<template>
  <section class="customer-stories" id="customers">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">我们的客户故事</h2>
        <p class="section-description">
          与各行各业的优秀企业合作，我们帮助客户实现数字化转型，
          创造卓越的商业价值和用户体验。
        </p>
      </div>
      
      <div class="stories-grid">
        <div class="story-card" v-for="story in stories" :key="story.id">
          <div class="story-image">
            <div class="image-placeholder" :style="{ background: story.imageBg }">
              <div class="image-content">{{ story.imageIcon }}</div>
            </div>
          </div>
          <div class="story-content">
            <h3 class="story-title">{{ story.title }}</h3>
            <p class="story-description">{{ story.description }}</p>
            <a href="#" class="story-link">
              了解更多
              <span class="arrow">→</span>
            </a>
          </div>
        </div>
      </div>
      
      <div class="section-actions">
        <button class="btn btn-primary btn-large">查看更多案例</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CustomerStoriesSection',
  data() {
    return {
      stories: [
        {
          id: 1,
          title: '传统零售数字化转型',
          description: '为某大型连锁零售企业打造全渠道数字化解决方案，包括线上商城、移动APP、智能POS系统等，实现线上线下业务一体化，提升客户体验和运营效率。',
          imageIcon: '🏪',
          imageBg: 'linear-gradient(135deg, #f3f4f6, #e5e7eb)'
        },
        {
          id: 2,
          title: '智能物流管理系统',
          description: '开发基于AI的智能物流管理平台，实现货物追踪、路径优化、库存管理等功能，帮助物流企业提升配送效率30%，降低运营成本20%。',
          imageIcon: '🚚',
          imageBg: 'linear-gradient(135deg, #d1fae5, #a7f3d0)'
        },
        {
          id: 3,
          title: '金融科技平台建设',
          description: '构建安全可靠的金融科技平台，集成支付、风控、数据分析等核心功能，为金融机构提供数字化转型支持，确保业务安全稳定运行。',
          imageIcon: '🚂',
          imageBg: 'linear-gradient(135deg, #fef3c7, #fde68a)'
        }
      ]
    }
  }
}
</script>

<style scoped>
.customer-stories {
  padding: 100px 0;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-header {
  text-align: center;
  margin-bottom: 80px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 24px 0;
}

.section-description {
  font-size: 1.125rem;
  line-height: 1.7;
  color: #6b7280;
  margin: 0;
  max-width: 800px;
  margin: 0 auto;
}

.stories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 32px;
  margin-bottom: 64px;
}

.story-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.story-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.story-image {
  height: 200px;
  position: relative;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.image-content {
  font-size: 4rem;
  opacity: 0.7;
}

.story-content {
  padding: 32px;
}

.story-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 12px 0;
}

.story-description {
  font-size: 0.875rem;
  line-height: 1.6;
  color: #6b7280;
  margin: 0 0 20px 0;
}

.story-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #3C59FF;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}

.story-link:hover {
  color: #09D6F9;
  gap: 12px;
}

.arrow {
  transition: transform 0.3s ease;
}

.story-link:hover .arrow {
  transform: translateX(4px);
}

.section-actions {
  text-align: center;
}

.btn-primary {
  background: linear-gradient(135deg, #3C59FF, #09D6F9);
  color: white;
  border: none;
}

.btn-primary:hover {
  background: linear-gradient(135deg,#3C59FF, #09D6F9);
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .customer-stories {
    padding: 60px 0;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .stories-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  
  .story-content {
    padding: 24px;
  }
}
</style>
